import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routesPC = [
  {
    path: '/',
    redirect: 'home'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/PC/home/index.vue')
  },
  {
    path: '/ekyc',
    name: 'ekyc',
    component: () => import('@/views/PC/EKYC/index.vue')
  },
  {
    path: '/creditScore',
    name: 'creditScore',
    component: () => import('@/views/PC/creditScore/index.vue')
  },
  {
    path: '/antiFraud',
    name: 'antiFraud',
    component: () => import('@/views/PC/clAntiFraud/index.vue')
  },
  {
    path: '/lunaAi',
    name: 'lunaAi',
    component: () => import('@/views/PC/lunaAi/index.vue')
  },
  {
    path: '/aiAds',
    name: 'aiAds',
    component: () => import('@/views/PC/clAiAds/index.vue')
  },
  {
    path: '/company',
    name: 'company',
    component: () => import('@/views/PC/company/index.vue')
  },
  {
    path: '/solution',
    name: 'solution',
    component: () => import('@/views/PC/solution/index.vue')
  }
]

const routesMobile = [
  {
    path: '/',
    redirect: 'home'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/mobile/home/index.vue')
  },
  {
    path: '/ekyc',
    name: 'ekyc',
    component: () => import('@/views/mobile/EKYC/index.vue')
  },
  {
    path: '/creditScore',
    name: 'creditScore',
    component: () => import('@/views/mobile/creditScore/index.vue')
  },
  {
    path: '/antiFraud',
    name: 'antiFraud',
    component: () => import('@/views/mobile/clAntiFraud/index.vue')
  },
  {
    path: '/aiAds',
    name: 'aiAds',
    component: () => import('@/views/mobile/clAiAds/index.vue')
  },
  {
    path: '/lunaAi',
    name: 'lunaAi',
    component: () => import('@/views/mobile/lunaAi/index.vue')
  },
  {
    path: '/company',
    name: 'company',
    component: () => import('@/views/mobile/company/index.vue')
  },
  {
    path: '/solution',
    name: 'solution',
    component: () => import('@/views/mobile/solution/index.vue')
  }
]

const isMobile = window.matchMedia('(max-width: 767px)').matches
const routes = isMobile ? routesMobile : routesPC
const router = new VueRouter({ routes })
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0) // 让页面滚动到顶部
  next()
})

export default router
